module.exports = __webpack_public_path__ + "img/chenosis.8c2b06d1.svg";